module.exports = __webpack_public_path__ + "static/img/图层 527.c96f13d5.png";